import { Box } from '@mui/material'
import React from 'react'
import { ReactImageGalleryItem } from 'react-image-gallery'
import ReactPanZoom from 'react-image-pan-zoom-rotate'

export function renderItem(item: ReactImageGalleryItem) {
  const itemSrc = item?.fullscreen ?? item.original
  return (
    <Box className="image-gallery-image" sx={{ overflow: 'hidden' }}>
      <ReactPanZoom image={itemSrc} alt={item.originalAlt} />
    </Box>
  )
}
